import * as React from 'react';
import {Redirect} from 'react-router-dom';

import {NotePage} from '../../ui/notes/note-page';

type Props = {
    noteId: string | null | undefined;
};

export function NotePageRoot(props: Props) {
    if (!props.noteId) {
        return <Redirect to='/sales/dashboard' />;
    }

    return <NotePage noteId={props.noteId} />;
}
